<template>
	<StickyBasket
			v-if="show"
			:basket="basket"
			:next-step="store.nextStep"
	/>
</template>

<script setup lang="ts">
	import {useStore} from '@/store';
	import {storeToRefs} from 'pinia';
	import StickyBasket from '@/components/basket/StickyBasket.vue';
	import {computed, ref} from 'vue';

	const store = useStore();
	const {basket} = storeToRefs(store);

	const mediaQuery = window.matchMedia('not (min-width: 992px)');
	const smallScreen = ref(mediaQuery.matches);

	mediaQuery.addEventListener('change', () => {
		smallScreen.value = mediaQuery.matches;
	});

	// TODO: also check if 'normal' Basket of next button is in viewport so we can hide this one
	const show = computed(() => smallScreen.value);
</script>

<style lang="scss">
	//	Needs to be global because this styling is outside of this component
	#app-sticky-basket {
		position: sticky;
		bottom: 0;
		background: #ffffff;
		box-shadow: 0 0 10px rgb(0, 0, 0, 20%);
	}
</style>
